import React from "react";
// import PulseLogo from "../../assets/pulse-logo.png";
import { PlaiHeaderProps } from "./plai-header.types";
import "./plai-header.css";
const PlaiHeader = (props: PlaiHeaderProps) => {
  return (
    <div className="w-full bg-white fixed nav  top-0 h-20 z-[1000]">
      <div className="max-w-[1440px] mx-auto plai-header-wrapper flex justify-between  h-full  items-center ">
        <img
          src={props.imgUrl}
          alt="Company Logo"
          className=" max-w-[140px] max-h-20 object-contain"
        />
        {/* <img src={PulseLogo} className="w-[69px] h-[32px]" alt="Pulse Logo" /> */}
      </div>
    </div>
  );
};

export default PlaiHeader;
